/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

/**
 * * `waive` - waive
 */
export type AmendPaymentWaiveRequestActionEnum = typeof AmendPaymentWaiveRequestActionEnum[keyof typeof AmendPaymentWaiveRequestActionEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AmendPaymentWaiveRequestActionEnum = {
  waive: 'waive',
} as const;
